const RESOURCE_NAME = '/shipments-types';
import restApi from "@/api/rest-api-object";

export default axios => (restApi(axios, RESOURCE_NAME));